import { TextButton } from '@design-system/components/button/button';
import { Row } from '@design-system/components/grid/grid';

type DuplicateSuccessToastProps = {
  programName: string;
  onOpen: () => void;
};

export const DuplicateSuccessToast = ({
  programName,
  onOpen,
}: DuplicateSuccessToastProps) => (
  <Row gap="m" alignCenter>
    <span>{`${programName} has been successfully duplicated.`}</span>
    <TextButton onClick={onOpen} testId="program-duplicate-toast-open">
      Open
    </TextButton>
  </Row>
);
